class SmoothAnchorScroll {
    constructor() {
        this.elements = document.querySelectorAll('a[href^="#"]');
        this.init();
    }

    init() {
        if( !this.elements.length ) return;
        
        this.elements.forEach(element => {
            if( element.getAttribute('href') == '#' ) return;
            
            element.addEventListener('click', (e) => {
                e.preventDefault();
                const target = document.querySelector(element.getAttribute('href'));
                
                if( target) {
                    target.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            });
        });

        if( window.location.hash ) {
            const target = document.querySelector(window.location.hash);

            if( target) {
                target.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    }
}

new SmoothAnchorScroll();